import { useEffect, useState } from 'react';
import { useQueryLifecycle } from './useQueryLifecycle';
import { usePaymentsV2Query } from '../../../payments-v2/viewmodels/usePaymentsV2Query';
import { fetchTaskDetail } from '../../models/shared/taskDetailModel';
export const SALES_STAGES = ['draft', 'waiting_for_price', 'waiting_customer_confirmation', 'confirmed_waiting_payment'];
export const UNPARK_ORDER = [...SALES_STAGES, 'paid', 'waiting_purchase', 'purchased', 'out_for_delivery', 'delivered', 'completed', 'cancelled'];
export const stageLabel = stage => ({ draft: 'Draft', waiting_for_price: 'Waiting For Price', waiting_customer_confirmation: 'Waiting Confirmation', confirmed_waiting_payment: 'Confirmed · Awaiting Payment', cancelled: 'Lost' }[stage] || stage?.replace(/_/g, ' '));
export function backTargets(status) {
  const index = UNPARK_ORDER.indexOf(status);
  return index <= 0 ? [] : SALES_STAGES.slice(1).filter(stage => UNPARK_ORDER.indexOf(stage) < index).reverse();
}
export function unparkTargets(origin) {
  const index = UNPARK_ORDER.indexOf(origin);
  return index < 0 ? [] : UNPARK_ORDER.slice(0, index + 1).reverse();
}
export function useLifecycleDialog({ open, queryPk, kind, onSuccess, onClose }) {
  const lifecycle = useQueryLifecycle(queryPk);
  const payments = usePaymentsV2Query(queryPk, { enabled: open });
  const [error, setError] = useState(null);
  const [origin, setOrigin] = useState(null);
  useEffect(() => {
    setError(null); setOrigin(null);
    if (!open || kind !== 'unpark') return;
    let active = true;
    fetchTaskDetail(queryPk).then(result => { if (active) setOrigin(result?.task?.parked_from_status || null); }).catch(next => { if (active) setError(next); });
    return () => { active = false; };
  }, [open, queryPk, kind]);
  const authority = kind === 'cancel' ? payments.capability('can_cancel_query') : kind === 'back' ? payments.capability('can_move_back') : { allowed: !!origin, reason: 'Persisted parked origin is not available' };
  const submit = async values => {
    if (!authority.allowed || lifecycle.pending) return;
    try {
      const reason = { reason_code: values.reason_code, note: values.note || null };
      const result = kind === 'cancel' ? await lifecycle.cancel(reason) : kind === 'back' ? await lifecycle.moveBack(values.to_status, reason) : await lifecycle.unpark(values.to_status, reason);
      if (!result?.success) { const failure = new Error(result?.message); failure.code = result?.code; failure.data = result?.data; throw failure; }
      await onSuccess?.(); onClose?.();
    } catch (next) { setError(next); }
  };
  return { ...payments, error: error || payments.error, authority, origin, submit, saving: lifecycle.pending };
}
